import styled from 'styled-components';

export const StyledLi = styled.li`
  &:not(:first-child) {
    padding-top: 4px;
  }

  p {
    display: inline;
  }

  ul,
  ol {
    margin-top: 4px !important;
    margin-left: ${(p) => p.theme.space[3]};
  }
`;
